import React, { useMemo } from "react";

import { observer } from "mobx-react-lite";
import { Box, Grid, GridItem, IconChevronRightLight, skinVars, Tag, Text3, Divider, Text2 } from "@telefonica/mistica";
import { formatAmount, formatDate } from "../../../utils/formatters";
import { strings } from "../../../localization";

export enum TypeTag {
	IN_PROGRESS = "inactive",
	CANCELED = "error",
	FINISH = "success",
}

interface ContractItemProps {
	type: TypeTag;
	contractValue: number;
	date: string;
}

const { description, canceled, finished, inProgress } = strings.organisms.contractItem;

const ContractItem = observer(({type, contractValue, date}: ContractItemProps) => {

	const getTextTypeContract = useMemo(() => {
		switch (type) {
			case TypeTag.IN_PROGRESS:
				return inProgress;
			case TypeTag.CANCELED:
				return canceled;
			case TypeTag.FINISH:
				return finished;
		}
	} , [type]);

	return (
		<>
			<Box paddingY={16}>
				<Grid columns={{ maxSize: 600 }} rows={1} alignItems='center'>
					<GridItem columnStart={1} columnSpan={2}>
						<Grid columns={1} rows={4} justifyItems="start">
							<GridItem columnStart={1} columnSpan={1}>
								<Tag type={type}>
									{getTextTypeContract}
								</Tag>
							</GridItem>

							<GridItem columnStart={1} columnSpan={1}>
								<Text3 weight="regular" color={skinVars.colors.textPrimary}>
									{description}
								</Text3>
							</GridItem>

							<GridItem columnStart={1} columnSpan={1}>
								<Text2 weight="regular" color={skinVars.colors.textSecondary}>
									{formatAmount(contractValue)}
								</Text2>
							</GridItem>

							<GridItem columnStart={1} columnSpan={1}>
								<Text2 weight="regular" color={skinVars.colors.textSecondary}>
									{formatDate(date)}
								</Text2>
							</GridItem>
						</Grid>
					</GridItem>

					<GridItem columnStart={3} justifySelf="end">
						<IconChevronRightLight size={16} color={skinVars.colors.brand} />
					</GridItem>
				</Grid>
			</Box>

			<Divider />
		</>
	);
});

export default ContractItem;
